import axios from "axios";
import { servicePath } from "../../utility/data";

  export const userProfileUpdate = async (name, currency, accessToken) => {
    const payload = {
      name,
      currency
    };
  
    try {
      const response = await axios.post(`${servicePath}/users/profile-update`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error during user registration:', error);
      throw new Error(error.response ? error.response.data.message : 'User registration failed');
    }
  };